import { ObservableFromFetch } from "./ObservableFromFetch"

export const GetCoverLetter = (testEventId: number) => ObservableFromFetch<string>(`Results/CoverLetter?id=${testEventId}`)
export const SetCoverLetter = (testEventId: number) => ObservableFromFetch<void>('Results/CoverLetter', testEventId.toString() )